import { Component, OnInit, Renderer2, Injector, ElementRef, OnDestroy, AfterViewInit, HostBinding, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ScreenElementClass } from '../screen-element.class';
import { IScreenElement } from '../screen-element.interface';
import { SeShapeConfig } from './se-shape-config.class';
import { ICustomPropConfig } from '../../prop-editors.moudule/custom-prop-config.interface';
import { ICssShadow } from '../ICssShadow.interface';
import { InlineSVGDirective } from 'ng-inline-svg';

@Component({
  selector: 'app-se-shape',
  templateUrl: './se-shape.component.html',
  styleUrls: ['./se-shape.component.css']
})
export class SeShapeComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit {

  // text shadows
  @HostBinding('style.filter') get geTextShadows() {
    // build box shadow string with all the shadows
    let shadowStr = '';
    if (this.elementConfig.dropShadows.length > 0) {
      this.elementConfig.dropShadows.forEach((shadow: ICssShadow) => {
        shadowStr += `drop-shadow(${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}), `;
      });
      shadowStr = shadowStr.substring(0, shadowStr.length - 2); // remove last commma
    }
    return this.sanitizer.bypassSecurityTrustStyle(shadowStr);
  }

  @ViewChild('svg') svg: InlineSVGDirective;



  public elementConfig = new SeShapeConfig();
  public svgImage;

  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public renderer: Renderer2,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    super(sanitizer); // initilize base class
    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected

    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }
  }

  async ngOnInit() {




  }

  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
  }

  async ngAfterViewInit() {
    this.onElementReadySubject.next(this);
  }

  update() {
    if (this.elementConfig) {

      this.elementConfig.imageURL = '';

      this.changeDetectorRef.detectChanges();

      let bbox = null;
      if (this.svgImage) {
        bbox = this.svgImage.getBBox();
      }
      let to = setTimeout(() => {
        if ( bbox && bbox.height > 0 && bbox.width > 0) {
          this.svgImage.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width + (this.elementConfig.borderWidth * 2)} ${bbox.height + (this.elementConfig.borderWidth * 2)}`);
        }
        to = null;

      }, 1);

    }
  }

  onSVGInserted(svgElement) {
    this.svgImage = svgElement;
    const bbox = svgElement.getBBox();
    if (bbox.height > 0 && bbox.width > 0) {
      svgElement.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width + (this.elementConfig.borderWidth * 2)} ${bbox.height + (this.elementConfig.borderWidth * 2)}`);
    }
    svgElement.setAttribute('preserveAspectRatio', 'none');
  }

  getCustomProperties() {
    const props = [];

    const strokeOpacity: ICustomPropConfig = {
      type: 'pe-slider',
      name: 'Stroke Opacity',
      propPath: 'elementConfig.strokeOpacity',
      defaultValue: 1,
      tooltip: 'Reset to default',
      showDefaultReset: true,
      groupName: null,
      settings: {
        connect: [true, false],
        start: [1],
        range: {
          min: 0,
          max: 1
        },
        // step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };

    const borderWidth: ICustomPropConfig = {
      type: 'pe-spinner',
      name: 'Border Width',
      propPath: 'elementConfig.borderWidth',
      defaultValue: 0,
      tooltip: 'Border size around the element in pixels',
      showDefaultReset: true,
      groupName: null,
      settings: {
        min: 0,
        max: 100,
        step: 1
      }
    };

    const strokeWidthSlider: ICustomPropConfig = {
      type: 'pe-slider',
      name: 'Outline Width',
      propPath: 'elementConfig.strokeWidth',
      defaultValue: 0,
      tooltip: 'Outline size around the element in pixels',
      showDefaultReset: true,
      groupName: null,
      settings: {
        connect: [true, false],
        start: [0],
        range: {
          min: 0,
          max: 2
        },
        step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };

    const borderRadius: ICustomPropConfig = {
      type: 'pe-slider',
      name: 'Border Radius',
      propPath: 'elementConfig.borderRadius',
      defaultValue: 0,
      tooltip: 'The amount of curve on the corners of the border',
      showDefaultReset: true,
      groupName: null,
      settings: {
        connect: [true, false],
        start: [0],
        range: {
          min: 0,
          max: 100
        },
        // step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };

    const strokeColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Outline Color',
      propPath: 'elementConfig.strokeColor',
      defaultValue: '#212121',
      tooltip: 'The color of the outline',
      showDefaultReset: true,
      groupName: null, // will show in settings
      settings: {
      }
    };

    const fillColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Fill Color',
      propPath: 'elementConfig.fillColor',
      defaultValue: '#212121',
      tooltip: 'The color of the interior or the shape',
      showDefaultReset: true,
      groupName: null, // will show in settings
      settings: {
      }
    };

    const dropShadows: ICustomPropConfig = {
      type: 'pe-shadoweditor',
      name: 'Drop Shadow',
      propPath: 'elementConfig.dropShadows',
      defaultValue: new Array<ICssShadow>(),
      tooltip: 'Show drop shadows on shape',
      showDefaultReset: true,
      groupName: 'effects',
      settings: {
        hasSpread: false,
        buttonText: 'Add Drop Shadow',
        horizontal: {
          type: 'pe-slider',
          name: 'Position X',
          propPath: 'x',
          defaultValue: 10,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [10],
            step: 1,
            range: {
              min: -200,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, vertical: {
          type: 'pe-slider',
          name: 'Position Y',
          propPath: 'y',
          defaultValue: 10,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [10],
            step: 1,
            range: {
              min: -200,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, blur: {
          type: 'pe-slider',
          name: 'Blur',
          propPath: 'blur',
          defaultValue: 7,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [7],
            range: {
              min: 0,
              max: 30
            },
            step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, spread: {
          type: 'pe-slider',
          name: 'Spread',
          propPath: 'spread',
          defaultValue: 1,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [1],
            step: 1,
            range: {
              min: -50,
              max: 100
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        },
        colorConfig: {
          type: 'pe-colorpicker',
          name: 'Color',
          propPath: 'color',
          defaultValue: 'rgba(150,150,150,1)',
          tooltip: 'Sets the color of the shadow',
          showDefaultReset: true,
          groupName: null,
          settings: {
          }


        }

      }
    };


    props.push(fillColor);
    props.push(strokeWidthSlider);
    props.push(strokeColor);
    props.push(strokeOpacity);
    props.push(dropShadows);

    return props;
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-shape/se-shape.component.ts